import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { ShiftResource, shiftsCancel } from '~/generated';
import { extractData } from '~/utils/query-utils';

export const useCancelShift = (
  options: UseMutationOptions<
    ShiftResource,
    unknown,
    { id: number; cancellationReason: string },
    unknown
  > = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, cancellationReason }) => {
      return extractData(
        shiftsCancel({
          path: { id },
          body: {
            cancellationReason,
          },
        })
      );
    },
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({
        queryKey: ['shifts', variables.id],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
